import { App, Button, Dropdown, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';
import {
  ModalAppPdfData,
  ModalAppStatementOfAccount,
} from '../../components/upeosoft/ModalApp/ModalApp';
import { CheckOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { TbDotsVertical } from 'react-icons/tb';
import {
  deleteStatementOfAccount,
  getStatementOfAccount,
  getStatementOfAccountPdf,
} from '../../network/statementOfAccount';
import DashboardCards from '../Dashboard/DashboardCards';
const StatementOfAccount = ({ t }) => {
  const client = useQueryClient();
  const navigate = useNavigate();
  const [nameInvoice, setNameInvoice] = useState('');
  const [openPdf, setOpenPdf] = useState(false);
  const { message } = App.useApp();
  const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getStatementOfAccount],
    queryFn: () => getStatementOfAccount(),
    keepPreviousData: true,
  });
  // const { onGetPDF, pdfData } = UseDownloadPdf();
  const { mutate: onGetPDF, data: pdfData,setLoadingPdf, loadingPdf } = useMutation({
    mutationKey: ['getPDF'],
    mutationFn: (name) => getStatementOfAccountPdf(name),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
    },
  });
  const handleRemove = useMutation({
    mutationFn: (id) => deleteStatementOfAccount(id),
    onSuccess: (data) => {
      // console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getStatementOfAccount],
      });
    },
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.StatementOfAccount,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setOpen(true);
        setEdit(true);
        setEditId(record.name);
      },
    },
    {
      key: '6',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        onGetPDF(record.name);
        setOpenPdf(true);
        setNameInvoice(record.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          description={t.areYouSure}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.StatementOfAccount}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.year).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: t.FromDate,
      dataIndex: 'from_date',
    },
    {
      title: t.ToDate,
      dataIndex: 'to_date',
    },

    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Dropdown
              menu={{ items: items(record) }}
              trigger={['click']}
              overlayClassName="custom-dropdown"
              // placement="bottomCenter"
            >
              <Button
                size="small"
                type="text"
                icon={<TbDotsVertical size={20} />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      ...item,
      key: index,
    };
  });
  return (
    <div className="fiscal-year-table">
      {/* <Heading title={t.reports} subTitle={t.StatementOfAccount} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />{' '}
              {t.AddStatementOfAccount}
            </Button>
          }
          Placeholder={t.Search}
          // pathBtn="/modeofpayments/add"
        />
      </div>
      <ModalAppStatementOfAccount
        t={t}
        open={open}
        setEditId={setEditId}
        setEdit={setEdit}
        setOpen={setOpen}
        edit={edit}
        record={editId}
      />
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        // type="Sales Invoice"
        type="Statement Of Account"
                setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
    </div>
  );
};

export default StatementOfAccount;
